import { useLocation } from '@thd-olt-component-react/router';

export function useUrlTmxId() {
  return (new URLSearchParams(useLocation().search)).get('guid');
}
